var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAgendaGrey = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.062,
    height: 31.062,
    viewBox: "0 0 31.062 31.062",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0.7;}.b{fill:none;}.c{fill:#484a56;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,0H31.062V31.062H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M21.119,12.648H8.177v2.588H21.119Zm2.588-9.06H22.413V1H19.825V3.588H9.471V1H6.883V3.588H5.588A2.577,2.577,0,0,0,3.013,6.177L3,24.3a2.588,2.588,0,0,0,2.588,2.588H23.708A2.6,2.6,0,0,0,26.3,24.3V6.177A2.6,2.6,0,0,0,23.708,3.588Zm0,20.708H5.588V10.06H23.708Zm-6.471-6.471H8.177v2.588h9.06Z",
    transform: "translate(0.883 0.294)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAgendaGrey);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/agenda-grey.ff0ed6d60d7ac493eb81f725e86e85a8.svg";